angular.module('tf.services')

    .service('FileParsingService', ['$q', function($q){

        function parseCSV(csv){
            return Papa.parse(csv.trim());
        }
        function isCSV(filename){
            return filename.endsWith('.csv');
        }

        var sheetMimeTypes = ['text/csv',
            'application/vnd.ms-excel',
            'application/msexcel',
            'application/x-msexcel',
            'application/x-ms-excel',
            'application/x-excel',
            'application/x-dos_ms_excel',
            'application/xls',
            'application/x-xls',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];

        this.isSheetFile = function(type){
            return sheetMimeTypes.indexOf(type) > -1;
        };

        this.parseSheet = function(file){
            var defer = $q.defer();
            if(this.isSheetFile(file.type)){
                var reader = new FileReader();
                reader.readAsBinaryString(file);
                $(reader).on('load', function (e) {
                    var text = e.target.result;
                    if(!isCSV(file.name)){
                        var workbook = XLSX.read(text, {type:'binary'});
                        var firstSheetName = workbook.SheetNames[0];
                        text = XLSX.utils.sheet_to_csv(workbook.Sheets[firstSheetName]);
                    }
                    var data = parseCSV(text).data;
                    defer.resolve(data);
                });
            } else {
                defer.reject();
            }
            return defer.promise;
        };

        return this;

    }]);
